import { render, staticRenderFns } from "./IconPeople.vue?vue&type=template&id=c80cf456&"
import script from "./IconPeople.vue?vue&type=script&lang=js&"
export * from "./IconPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c80cf456')) {
      api.createRecord('c80cf456', component.options)
    } else {
      api.reload('c80cf456', component.options)
    }
    module.hot.accept("./IconPeople.vue?vue&type=template&id=c80cf456&", function () {
      api.rerender('c80cf456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPeople.vue"
export default component.exports